<template>
  <footer class="footer">
    <div class="inner">
      <div class="footer-left">
        <ul class="footer-nav">
          <li>
            <a type="link" href="#" @click="commonRedirect(bopMaintenanceUrl)"
              >メンテナンス情報</a
            >
          </li>
          <li>
            <a
              type="link"
              href="#"
              @click="commonRedirect(bopSiteAdministratorUrl)"
              >サイトの運営者</a
            >
          </li>
          <li>
            <a type="link" href="#" @click="commonRedirect(bopPrivacyPolicyUrl)"
              >プライバシーポリシー</a
            >
          </li>
          <li>
            <a type="link" href="#" @click="commonRedirect(bopSitePolicyUrl)"
              >サイトポリシー</a
            >
          </li>
          <li>
            <a type="link" href="#" @click="commonRedirect(bopTermsOfUseUrl)"
              >利用規約</a
            >
          </li>
          <li>
            <a
              type="link"
              href="#"
              @click="commonRedirect(bopRecommendedEnvironment)"
              >推奨環境</a
            >
          </li>
        </ul>
      </div>
      <div class="footer-right">
        <p class="copyright">Copyright © NTT DATA Japan Corporation</p>
      </div>
    </div>
  </footer>
</template>
<script>
import Common from "@/util/common.js";

export default {
  name: "BopFooter",
  data() {
    return {
      bopSiteAdministratorUrl: Common.getSettingsValue("BopSiteAdministratorUrl"),
      bopPrivacyPolicyUrl: Common.getSettingsValue("BopPrivacyPolicyUrl"),
      bopSitePolicyUrl: Common.getSettingsValue("BopSitePolicyUrl"),
      bopTermsOfUseUrl: Common.getSettingsValue("BopTermsOfUseUrl"),
      bopRecommendedEnvironment: Common.getSettingsValue("BopRecommendedEnvironment"),
      bopMaintenanceUrl: Common.getSettingsValue("BopMaintenanceUrl"),
    };
  },
  computed: {},
  created() {},
  methods: {
    // **********************************************
    // URL開く
    // **********************************************
    commonRedirect(path) {
      window.open(
        path,
        "",
        "width=1240,height=760,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no"
      );
    },
    // **********************************************
    // URL開く
    // **********************************************
    commonRedirectMaintenance(path) {
      window.open(path);
    },
  },
};
</script>

<style scoped>
  
@media screen and (max-width: 1200px) and (min-width: 769px) {

  /* footer */ 
  .footer>.inner {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-top: 20px;
    padding-bottom: 10px;
    min-width: unset !important; 

  }
}
</style>
